// registerServiceWorker.js - Registar Service Worker no React
import i18n from './i18n';
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('✅ Service Worker registado:', registration);

          // Verificar atualizações a cada hora
          setInterval(() => {
            registration.update();
          }, 60 * 60 * 1000);

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            
            if (installingWorker == null) {
              return;
            }

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // Nova versão disponível
                  console.log('🔄 Nova versão disponível! Recarregue a página.');
                  
                  // Mostrar notificação ao utilizador
                  if (window.confirm(i18n.t('erros.novaVersao'))) {
                    installingWorker.postMessage({ action: 'skipWaiting' });
                    window.location.reload();
                  }
                } else {
                  // Conteúdo em cache para uso offline
                  console.log('✅ Conteúdo em cache para uso offline.');
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('❌ Erro ao registar Service Worker:', error);
        });

      // Recarregar quando novo service worker toma controle
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('❌ Erro ao desregistar Service Worker:', error);
      });
  }
}

// Verificar se está online/offline
export function checkOnlineStatus() {
  window.addEventListener('online', () => {
    console.log('✅ Online: Conexão restaurada');
    
    // Sincronizar dados
    if ('serviceWorker' in navigator && 'SyncManager' in window) {
      navigator.serviceWorker.ready.then((registration) => {
        return registration.sync.register('sync-data');
      });
    }
  });

  window.addEventListener('offline', () => {
    console.log('⚠️ Offline: Sem conexão à internet');
  });
}

// Prompt de instalação PWA
let deferredPrompt;

export function initInstallPrompt() {
  window.addEventListener('beforeinstallprompt', (e) => {
    console.log('📱 PWA: Prompt de instalação disponível');
    
    // Prevenir o mini-infobar do Chrome no mobile
    e.preventDefault();
    
    // Guardar evento para usar depois
    deferredPrompt = e;
    
    // Mostrar botão de instalação customizado (se houver)
    const installButton = document.getElementById('install-button');
    if (installButton) {
      installButton.style.display = 'block';
      
      installButton.addEventListener('click', async () => {
        if (!deferredPrompt) {
          return;
        }
        
        // Mostrar prompt
        deferredPrompt.prompt();
        
        // Aguardar escolha do utilizador
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`📱 PWA: Utilizador ${outcome === 'accepted' ? 'aceitou' : 'recusou'} instalação`);
        
        // Limpar prompt
        deferredPrompt = null;
        installButton.style.display = 'none';
      });
    }
  });

  // App instalada
  window.addEventListener('appinstalled', () => {
    console.log('✅ PWA: App instalada com sucesso!');
    deferredPrompt = null;
  });
}

// Verificar se está instalado como PWA
export function isPWA() {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone ||
         document.referrer.includes('android-app://');
}

// Inicializar tudo
export function init() {
  register();
  checkOnlineStatus();
  initInstallPrompt();
  
  // Log do modo
  if (isPWA()) {
    console.log('✅ Rodando como PWA instalada');
  } else {
    console.log('🌐 Rodando no browser');
  }
}
